
import axios from "axios";
import headings from "~/mixins/headings.js";

export default {
  mixins: [headings],

  async asyncData({ store, params, error, redirect }) {
    try {
      const { data } = await axios.get(
        /* `${store.state.wsPath}get?type=wc&ws=product/${params.id}&lang=${store.state.lang}&market=${store.state.market}` */

        `${store.state.wsPath}get-product-2025?lang=${store.state.lang}&market=${store.state.market}&slug=${params.id}`
      );

      if (data.status == "error") {
        return redirect(`/${params.locale}/find-products`);
      }

      if (!data.headings.scripts) {
        data.headings.script = [];
      }

      data.headings.script.push({
        type: "application/ld+json",
        innerHTML: JSON.stringify({
          "@context": "https://schema.org/",
          "@type": "Product",
          name: data.hero[0].data.codice,
          image: [
            `https://res.cloudinary.com/thinking/image/upload/q_auto:eco/${store.state.cloudinaryFolder}/${data.hero[0].data.media.src_jpg}`,
          ],
          description: data.hero[0].data.description,
          brand: {
            "@type": "Brand",
            name: "Fantini",
          },
        }),
      });

      return {
        data,
      };
    } catch (e) {
      error({ statusCode: 500, message: store.state.labels.error_occurred });
    }
  },
};
